export default __webpack_public_path__ + "static/media/28t.71d1d90c.jpg";